import * as Effects from 'redux-saga/effects'
import { takeEvery } from 'redux-saga/effects'
import { callFetch } from '../../actions/fetch'
import { ActionNames } from '../../utils/FetchActionsName'
import fetchActionsName from '../../utils/FetchActionsName/fetchActionsName'
import { RentLicensesActions } from '../../reducers/rentLicenses/actionNames'
import { IRentLicense } from '../../reducers/rentLicenses'
import { getCalendarId } from '../../reducers/bookingCalendar/selectors/calendar'
import fetchRentLicenses from '../../models/RentLicenses/fetchRentLicenses'
import { getSortedRoomsByPosition } from '../../reducers/bookingCalendar/selectors/rooms'
import { RoomActions } from '../../reducers/bookingCalendar/actionNames'

function* loadRentLicenses() {
  try {
    const actionNames = fetchActionsName(ActionNames.FetchRentLicenses)
    const [{ service }] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.put(
        callFetch(actionNames.input, actionNames.output, fetchRentLicenses),
      ),
    ])

    const calendarId = yield Effects.select(getCalendarId)

    let rentLicensees: IRentLicense[] = yield Effects.call(service, calendarId)
    const rooms = yield Effects.select(getSortedRoomsByPosition)

    const allRoomsSelected = rentLicensees
      ? rentLicensees.reduce((acc, item) => {
          if (item.rooms) {
            return acc.concat(item.rooms)
          }
          return acc
        }, [])
      : []

    if (rooms.length !== allRoomsSelected.length) {
      rentLicensees = rentLicensees.map(l => {
        if (l.selection_type === '2' || l.selection_type === '0') {
          return { ...l, selection_type: '1' }
        }

        return l
      })
    }

    yield Effects.put({
      type: RentLicensesActions.RentLicensesAccepted,
      payload: rentLicensees,
    })
  } catch (e) {
    console.error(e)
  }
}

export default function*() {
  yield Effects.takeEvery(
    RentLicensesActions.LoadRentLicenses,
    loadRentLicenses,
  )
  yield takeEvery(RoomActions.RoomWasDeleted, loadRentLicenses)
}
